var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRouterReady)?_c(_vm.layout,_vm._g({tag:"component"},_vm.layoutEvents),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }